const firebaseConfig = {
  apiKey: "AIzaSyCZ0ODVs57WF-TAwhGLp1449LYREP-h_ak",
  authDomain: "tour-jackpot.firebaseapp.com",
  projectId: "tour-jackpot",
  storageBucket: "tour-jackpot.appspot.com",
  messagingSenderId: "115563878496",
  appId: "1:115563878496:web:c4d141d53f1bd7ae2ccb05"
};
export default firebaseConfig;